var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{staticClass:"footnote-link",attrs:{"href":`#footnote-${_vm.footnote}`,"data-rpa-tag-id":_vm.dataRPATagId,"aria-label":`See footnote ${_vm.footnote}`},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.footnote))]),_vm._v(" "),_c('v-breakpoint',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }